<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Verify',
  created() {
    this.$store.dispatch('rdstation/getResponseCode', this.activeAccount);
  },
  computed: mapGetters({
    activeAccount: 'account/active',
  }),
};
</script>



// WEBPACK FOOTER //
// Verify.vue?6beae0ff